<template>
    <div class="page">
        <public-head title="职业详情"></public-head>
        <div v-if="detail">
            <div class="nav">
                <div class="nav-table">
                    <div :class="currentTab==0?'nav-table-style':''" @click="swichNav(0)">基本信息</div>
                    <div
                        :class="currentTab==1?'nav-table-style':''"
                        @click="swichNav(1)"
                    >从业资格</div>
                    <div
                        :class="currentTab==2?'nav-table-style':''"
                        @click="swichNav(2)"
                    >现状及前景</div>
                </div>
            </div>
            <div class="ConArea">
                <div class="content">
                    <div class="content-one">
                        <div class="content-one-title">
                            <div class="major">
                                <div>{{bank.name}}</div>
                                  <div :class="bank.is_shoucang==1?'color':'shoucang'" @click="shoucang(bank.id)"><van-icon name="star" />收藏</div>
                            </div>
                            <!-- <div class="b_right">
                           
                                <button class="font_family icon-fenxiang1 sharebtn"></button>
                                <div class="line"></div>
                             
                                <button
                                    :class="["font_family", "sharebtn", celled?"celled icon-shoucangshixin":"icon-shoucang"]"
                                    @click="shoucang(bank.id)"
                                ></button>
                            </div> -->
                        </div>
                    </div>
                    <!-- current="{{currentTab}}" duration="300" -->
                    <div class="tab-content" bindchange="switchTab">
                        <div>
                            <div class="scroll-content" v-if="currentTab==0">
                                <div class="content-two">
                                    <div class="content-two-title">
                                        <div>职业简介</div>
                                        <!-- <div class="iconfont icon-xiajiantou1 title-icon"></div> -->
                                    </div>
                                    <div class="content-text">
                                        <div>{{detail.abstract}}</div>
                                    </div>
                                </div>

                                <div class="content-three">
                                    <div class="content-two-title">
                                        <div>工作内容</div>
                                        <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                    </div>
                                    <div class="content-text">
                                        <div>{{detail.job_content}}</div>
                                    </div>
                                </div>

                                <div class="content-three">
                                    <div class="content-two-title">
                                        <div>职业技能</div>
                                        <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                    </div>
                                    <div class="content-text">
                                        <div>{{detail.job_skill}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="scroll-content" v-if="currentTab==1">
                                <div class="content-three">
                                    <div class="content-two-title">
                                        <div>知识背景</div>
                                        <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                    </div>
                                    <div class="content-text">
                                        <div>{{detail.knowledge}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="scroll-content" v-if="currentTab==2">
                                <div class="content-three">
                                    <div class="content-two-title">
                                        <div>行业发展前景</div>
                                        <div class="iconfont icon-xiajiantou1 title-icon"></div>
                                    </div>
                                    <div class="content-text">
                                        <div>{{detail.prospects_development}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div style="text-align:center;font-size:24rpx;background:#fff;padding:40rpx;">抱歉!!!暂无数据</div>
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data() {
        return {
            bank: [],
            detail: [],
            winHeight: "", //窗口高度
            currentTab: 0, //预设当前项的值
            scrollLeft: 0, //tab标题的滚动条位置
            celled: false,
            isretrue: 0,
            major_id: 0,
            celled:false
        };
    },
    created() {},
    methods: {
        // 点击收藏
        shoucang(e){
            
         
        if (this.$store.state.userInfo.user_id!= null) {
             httpPost("/usercell/job_cell", {
                      uid:this.$store.state.userInfo.user_id,
                     job_id: e
                }).then(res => {
                    if (res.msg=="收藏成功") {
                       this.bank.is_shoucang=1;
                        this.$toast.success(res.msg);
                    }else{
                         this.bank.is_shoucang=0;
                         this.$toast.fail(res.msg);
                    }
            })
        }else{
            this.$toast.fail("请先去登录")
        }
        },
        // 点击菜单栏切换
        swichNav(e) {
            if (this.currentTaB == e) {
                return false;
            } else {
                this.currentTab = e;
                  this.fetchDetail(this.$route.query.id) 
            }   
        },

        // 获取职业库详情数据
        fetchDetail(id) {
            httpPost("/job/detail", {
                id: id
            }).then(res => {
              
                if (res.code === 1) {
                    (this.detail = res.detail),
                        (this.bank = res.bank),
                        (this.celled = res.detail.celled);
                } else {
                    (this.data = ""), (this.bank = ""), (this.celled = false);
                }
            });
          
        }
    },
    mounted() {
        this.fetchDetail(this.$route.query.id);
         this.major_id=this.$route.query.id; 
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.page {
    background: #f2f2f2;
}

.nav {
    height: 3.125rem;
    background: #22d9d9;
    /* font-size: 0.875rem; */
    color: #fff;
    line-height: 2.8125rem;
    margin-top: 46px;
}

.nav-table {
    width: 75%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    padding-top: 0.3125rem;
}

.nav-table div {
    height: 2.1875rem;
    padding: 0 0.8125rem;
    line-height: 2.1875rem;
}

.nav-table-style {
    background: #6de7e7;
    border-radius: 1.25rem;
}

.ConArea {
    background: #fafafa;
    padding: 0.625rem 0.9375rem;
    overflow: hidden;
}
.content {
    background: #fff;
    box-shadow: 4px 5px 6px #ccc;
}

.content-one {
    padding: 20rpx;
    border-bottom: 1px solid #ccc;
}

.content-one-title {
    display: flex;
    justify-content: space-between;
}

.major {
    font-size: 1.0625rem;
    line-height: 2;
}

.b_right {
    width: 5.625rem;
    height: 1.875rem;
    background: #bcbcbc;
    display: flex;
    justify-content: space-around;
    border-radius: 5px;
    line-height: 1.875rem;
}

.share {
    color: #fff;
    font-size: 1.375rem;
    margin-left: 0.375rem;
    margin-top: 0.1875rem;
}

.share2 {
    color: #fff;
    font-size: 1.4375rem;
    line-height: 1.4;
}

.line {
    height: 70%;
    width: 1px;
    background: #fff;
    margin-top: 5%;
}
.color{
     line-height: 1.625rem;
    width: 3.375rem;
    height: 1.625rem;
    background: #bcbcbc;
    font-size: 0.875rem;
    color: rgb(233, 248, 1);
    text-align: center;
    border-radius: 0.625rem;
    margin-left:7.5rem;
    margin-top: 0.375rem;
   
}
.major {
    font-size: 1.125rem;
    line-height: 2;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right:1.25rem;
    width: 100%
}
.shoucang{
    line-height: 1.625rem;
    width: 3.375rem;
    height: 1.625rem;
    background: #bcbcbc;
    font-size: 0.875rem;
    color: #fff;
    text-align: center;
    border-radius: 0.625rem;
    margin-left:7.5rem;
    margin-top: 0.375rem;
}
.major-degree {
    display: flex;
    justify-content: space-between;
    font-size: 0.875rem;
    color: #999;
    padding-right: 2.5rem;
}

.content-two,
.content-three {
    padding: 0.625rem;
    border-bottom: 1px solid #ccc;
}

.content-two-title {
    font-size: 1.125rem;
    display: flex;
    justify-content: space-between;
}

.title-icon {
    font-size: 1.25rem;
    color: #999;
}

.content-text {
    font-size: 1rem;
    color: #666;
    padding: 0.625rem 0;
    line-height: 1.5;
    letter-spacing: 2px;
}

.canvas {
    width: 23.4375rem;
    height: 15.625rem;
}
.Salary-curve {
    padding-top: 0.9375rem;
}

/**************/
.header {
    height: 2.5rem;
    background: #22d9d9;
    display: flex;
    justify-content: space-around;
    padding: 0 0.625rem;
}

.header-title {
    font-size: 0.875rem;
    color: #fff;
    padding-top: 0.625rem;
}

.header-flex {
    display: flex;
}

.header-title-icon {
    font-size: 1rem;
    color: #fff;
    line-height: 2.6;
    padding-left: 0.3125rem;
}

.sArea {
    display: none;
    position: absolute;
    top: 2.5rem;
    height: auto;
    line-height: 2.0625rem;
    background: #22d9d9;
    font-size: 0.875rem;
    padding: 0.3125rem 0.625rem;
    color: #fff;
    width: 0%;
    transition: width 2s;
    overflow: hidden;
}

.sArea div {
    float: left;
    width: 25%;
    text-align: center;
    overflow: hidden;
}

.show {
    display: div;
    width: 100%;
}

.yellow {
    color: yellow;
}

.empty {
    padding: 0.9375rem;
    font-size: 0.9375rem;
    text-align: center;
}

.listArea {
    display: div;
    width: 100%;
    overflow: hidden;
}
page {
    height: 100%;
}
.scroll-content {
    height: 100%;
}

.sharebtn {
    background: none;
    background: none;
    border: none;
    color: #fff;
    font-size: 1.25rem;
    height: 1.875rem;
    line-height: 1.875rem;
    width: 100%;
    padding: 0px 0.9375rem;
}

.celled {
    color: #e5b626;
    font-size: 1.6875rem;
    margin-left: -0.1875rem;
}
</style>